export enum AlarmCriticatlity {
  High = 'High',
  Medium = 'Medium',
  Low = 'Low',
  VeryLow = 'Very Low',
}
